import { render, staticRenderFns } from "./ImportExportItems.vue?vue&type=template&id=ff4d8d7a"
import script from "./ImportExportItems.vue?vue&type=script&lang=js"
export * from "./ImportExportItems.vue?vue&type=script&lang=js"
import style0 from "./ImportExportItems.vue?vue&type=style&index=0&id=ff4d8d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports